import ApplicationModel from './ApplicationModel';
import { SchoolJSON, TableName } from '../types/json_types';
import { ClassName } from '../types/types';
import Upgrade from './Upgrade';

export type SchoolShort = 'wm' | 'richmond' | 'methodist' | 'bland' | 'macon' | 'eckerd' | 'norfolk' | 'vsu';

class School extends ApplicationModel {
  name: string;
  short: SchoolShort;

  constructor(json: SchoolJSON) {
    super(json);

    this.name = json.name;
    this.short = json.short;
  }

  isMethodist(): boolean {
    return this.short === 'methodist';
  }

  isRichmond(): boolean {
    return this.short === 'richmond';
  }

  isWm(): boolean {
    return this.short === 'wm';
  }

  isBland(): boolean {
    return this.short === 'bland';
  }

  isEckerd(): boolean {
    return this.short === 'eckerd';
  }

  isMacon(): boolean {
    return this.short === 'macon';
  }

  isNorfolk(): boolean {
    return this.short === 'norfolk';
  }

  isVsu(): boolean {
    return this.short === 'vsu';
  }

  hasUpgrade(u: Upgrade): boolean {
    if (this.isMethodist()) {
      return u.methodist_price_cents != null;
    } else if (this.isRichmond()) {
      return u.richmond_price_cents != null;
    } else if (this.isBland()) {
      return u.bland_price_cents != null;
    } else if (this.isMacon()) {
      return u.macon_price_cents != null;
    } else if (this.isNorfolk()) {
      return u.norfolk_price_cents != null;
    } else if (this.isVsu()) {
      return u.vsu_price_cents != null;
    } else {
      return u.wm_price_cents != null;
    }
  }

  getClassName(): ClassName {
    const className: ClassName = 'School';
    return className;
  }

  static getTableName(): TableName {
    return 'schools';
  }
}

export default School;
